import {flexRender, type Header, type RowData} from "@tanstack/react-table";
import {clsx} from "clsx";
import {FA6Icon} from "@/primitives/FA6Icon";
import type {DataTableFeatures} from "./useDataTable";
import styles from "./DataTable.module.css";

/**
 * Sort toggle for a sortable column: the column's `header`
 * `DataTable.Content` uses it automatically — reach for it directly only in custom compositions.
 */
function DataTableSortableColumnHeader<TData extends RowData>({
	header,
	className,
	children,
	...props
}: React.ComponentProps<"button"> & {header: Header<DataTableFeatures, TData, unknown>}) {
	const column = header.column;
	const sorted = column.getIsSorted();
	return (
		<button
			type="button"
			data-slot="data-table-sortable-column-header"
			className={clsx(styles.sortButton, className)}
			onClick={column.getToggleSortingHandler()}
			{...props}
		>
			{children ?? flexRender(column.columnDef.header, header.getContext())}
			<FA6Icon
				icon={sorted === "asc" ? "sort-up" : sorted === "desc" ? "sort-down" : "sort"}
				className={clsx(styles.sortIcon, sorted === false && styles.sortIconIdle)}
			/>
		</button>
	);
}

export {DataTableSortableColumnHeader};
